import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AppConfigState, TransferSettingsState } from '@src/providers/AppConfigProvider/AppConfigProvider.types';

export const createTransferSettingsSlice = (appConfig: AppConfigState) => {
  const slice = createSlice({
    name: 'appConfig/transferSettings',
    initialState: appConfig.transferSettings satisfies TransferSettingsState,
    reducers: {
      setFavoriteTransferAssets: (state, action: PayloadAction<string[]>) => {
        state.favoriteTransferAssets = action.payload;
      },
      setRecentTransferSourceAccounts: (state, action: PayloadAction<Record<string, string[]>>) => {
        state.recentTransferSourceAccounts = action.payload;
      },
      setRecentTransferDestinationAccounts: (state, action: PayloadAction<Record<string, string[]>>) => {
        state.recentTransferDestinationAccounts = action.payload;
      },
    },
  });

  return {
    transferSettingsReducer: slice.reducer,
    actions: slice.actions,
  };
};
